"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayConnectionReportPageDto = exports.GetDisplayConnectionReportDto = void 0;
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
/** A report can select all displays whose name contains a term, or explicit IDs. */
class GetDisplayConnectionReportDto {
    search;
    displayIds;
    excludeDisplayIds;
    from;
    to;
    includeArchived;
}
exports.GetDisplayConnectionReportDto = GetDisplayConnectionReportDto;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Nombre de la flota en las pantallas, por ejemplo Cabify. Use search o displayIds, no ambos.",
        example: "Cabify",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100),
    __metadata("design:type", String)
], GetDisplayConnectionReportDto.prototype, "search", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [String],
        maxItems: 2000,
        description: "IDs alternativos a search; máximo 2000",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.ArrayMaxSize)(2000),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GetDisplayConnectionReportDto.prototype, "displayIds", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        type: [String],
        maxItems: 2000,
        description: "Pantallas excluidas del denominador del resumen",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.ArrayMaxSize)(2000),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], GetDisplayConnectionReportDto.prototype, "excludeDisplayIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2026-09-01T00:00:00.000Z",
        format: "date-time",
        description: "Inicio UTC, alineado a la hora",
    }),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], GetDisplayConnectionReportDto.prototype, "from", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2026-09-08T00:00:00.000Z",
        format: "date-time",
        description: "Fin UTC excluido, alineado a la hora; admite horas de hoy ya transcurridas; periodo máximo de 31 días",
    }),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], GetDisplayConnectionReportDto.prototype, "to", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        default: false,
        description: "Incluir pantallas archivadas en la búsqueda",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], GetDisplayConnectionReportDto.prototype, "includeArchived", void 0);
class GetDisplayConnectionReportPageDto extends GetDisplayConnectionReportDto {
    filter;
    page = 1;
    limit = 50;
    sortBy = "name";
    sortOrder = "asc";
}
exports.GetDisplayConnectionReportPageDto = GetDisplayConnectionReportPageDto;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Filtra la tabla por nombre o matrícula sin descargar todas las páginas",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100),
    __metadata("design:type", String)
], GetDisplayConnectionReportPageDto.prototype, "filter", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ minimum: 1, default: 1 }),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], GetDisplayConnectionReportPageDto.prototype, "page", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ minimum: 1, maximum: 100, default: 50 }),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], GetDisplayConnectionReportPageDto.prototype, "limit", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ enum: ["name", "connectedSeconds", "connectionPercent"], default: "name" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["name", "connectedSeconds", "connectionPercent"]),
    __metadata("design:type", String)
], GetDisplayConnectionReportPageDto.prototype, "sortBy", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({ enum: ["asc", "desc"], default: "asc" }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(["asc", "desc"]),
    __metadata("design:type", String)
], GetDisplayConnectionReportPageDto.prototype, "sortOrder", void 0);
